{
  "tabs": {
    "chat": "சாட்",
    "reminders": "நினைவூட்டல்கள்",
    "calendar": "காலண்டர்",
    "settings": "அமைப்புகள்"
  },
  "common": {
    "cancel": "ரத்து செய்",
    "save": "சேமி",
    "confirm": "உறுதிப்படுத்து",
    "delete": "அழி",
    "back": "பின்",
    "close": "மூடு",
    "edit": "திருத்து",
    "search": "தேடு",
    "all": "அனைத்து",
    "loading": "ஏற்றுகிறது...",
    "error": "ஏதோ தவறு நடந்தது",
    "notFound": "கண்டுபிடிக்கப்படவில்லை",
    "tryAgain": "மீண்டும் முயற்சி செய்க",
    "retry": "மீண்டும் முயற்சி",
    "undo": "மீட்டமை",
    "pullToRefresh": "புதுப்பிக்க இழுக்கவும்",
    "justNow": "இப்போது"
  },
  "auth": {
    "welcome": "FishMemoryக்கு வரவேற்கிறோம்",
    "tagline": "உங்கள் WhatsApp நினைவூட்டல் உதவியாளர், இப்போது உங்கள் கையில்.",
    "subtitle": "உங்கள் WhatsApp நினைவூட்டல் உதவியாளர், இப்போது உங்கள் கையில்.",
    "phoneLabel": "உங்கள் WhatsApp எண்",
    "phoneHint": "WhatsApp மூலம் சரிபார்ப்பு குறியீடு அனுப்பப்படும்",
    "invalidPhone": "சரியான தொலைபேசி எண்ணை உள்ளிடவும்",
    "continue": "தொடரவும்",
    "enterPhone": "உங்கள் WhatsApp எண்ணை உள்ளிடவும்",
    "phonePlaceholder": "தொலைபேசி எண்",
    "sendCode": "குறியீடு அனுப்பு",
    "verifyTitle": "உங்கள் எண்ணை சரிபார்க்கவும்",
    "otpSentTo": "6 இலக்க குறியீடு {{phone}}க்கு WhatsApp மூலம் அனுப்பப்பட்டது",
    "enterFullCode": "6 இலக்கங்களையும் உள்ளிடவும்",
    "invalidOtp": "தவறான குறியீடு. மீண்டும் முயற்சி செய்க.",
    "otpFailed": "குறியீடு அனுப்ப தோல்வி. மீண்டும் முயற்சி செய்க.",
    "otpResent": "குறியீடு மீண்டும் அனுப்பப்பட்டது",
    "resendIn": "{{seconds}} வினாடிகளில் மீண்டும் அனுப்பு",
    "resendCode": "குறியீடு மீண்டும் அனுப்பு",
    "enterOtp": "WhatsAppக்கு அனுப்பப்பட்ட குறியீட்டை உள்ளிடவும்",
    "verify": "சரிபார்க்கவும்",
    "resend": "குறியீடு மீண்டும் அனுப்பு",
    "wrongNumber": "தவறான எண்?",
    "backToPhone": "தொலைபேசிக்கு பின் செல்லவும்",
    "editPhone": "தொலைபேசி எண்ணை திருத்தவும்",
    "error": "பிழை",
    "setupTitle": "அமைப்புகளை அமைக்கலாம்",
    "setupSubtitle": "பின்னர் அமைப்புகளில் மாற்றலாம்",
    "namePlaceholder": "உங்கள் பெயர்",
    "letsGo": "அமைப்பை முடி",
    "skipForNow": "இப்போது தவிர்க்கவும்"
  },
  "chat": {
    "title": "FishMemory",
    "placeholder": "ஒரு செய்தி தட்டச்சு செய்க...",
    "inputPlaceholder": "ஒரு செய்தி தட்டச்சு செய்க...",
    "typing": "FishMemory தட்டச்சு செய்கிறது...",
    "online": "ஆன்லைன்",
    "connecting": "இணைக்கிறது...",
    "reconnecting": "மீண்டும் இணைக்கிறது...",
    "offline": "ஆஃப்லைன்",
    "empty": "ஒரு உரையாடலை தொடங்கு",
    "emptyHint": "நினைவூட்டல்கள் உருவாக்கவும், உங்கள் அட்டவணையை சரிபார்க்கவும், அல்லது உதவி கேளுங்கள்.",
    "emptyAction": "ஒரு மாதிரி நினைவூட்டல் அனுப்பு",
    "actions": "சாட் செயல்கள்",
    "keep": "செய்திகளை வைத்திரு",
    "clearTitle": "சாட் அழி",
    "clearConfirm": "இந்த சாதனத்தில் உள்ள அனைத்து செய்திகள் அழிக்கப்படவுள்ளன? இது திரும்ப பெற முடியாது.",
    "clear": "சாட் அழி",
    "optionSelected": "தேர்ந்தெடுக்கப்பட்டது: {{label}}",
    "sendingSelection": "அனுப்புகிறது...",
    "connectionLost": "மீண்டும் இணைக்கிறது..."
  },
  "reminders": {
    "title": "என் நினைவூட்டல்கள்",
    "active": "செயலில் உள்ளது",
    "today": "இன்று",
    "thisWeek": "இந்த வாரம்",
    "history": "வரலாறு",
    "items": "உருப்படிகள்",
    "emptyTitle": "இன்னும் நினைவூட்டல்கள் இல்லை",
    "emptySubtitle": "சாட் மூலம் ஒன்று உருவாக்கவும், அது இங்கே தோன்றும்.",
    "emptyAction": "சாட் திறக்கவும்",
    "filterActive": "செயலில் உள்ளது",
    "filterToday": "இன்று",
    "filterWeek": "இந்த வாரம்",
    "filterHistory": "வரலாறு",
    "emptyState": "இன்னும் நினைவூட்டல்கள் இல்லை. உரையாடலை தொடங்கு!",
    "swipeDone": "முடிந்தது",
    "swipeSnooze": "தாமதம்",
    "swipeDelete": "அழி",
    "search": "நினைவூட்டல்களை தேடு...",
    "upcoming": "வரவிருக்கும்",
    "completed": "முடிந்தது",
    "overdue": "காலாவதியானது",
    "tomorrow": "நாளை",
    "synced": "இணைக்கப்பட்டது {{value}}",
    "swipeHint": "மேலும் செயல்களுக்கு நினைவூட்டலை ஸ்வைப் செய்க",
    "noResults": "தேடல் பொருந்தும் நினைவூட்டல்கள் இல்லை",
    "noResultsHint": "வேறொரு சொல் முயற்சி செய்க அல்லது தேடலை அழி",
    "deleteAllFailed": "அனைத்து நினைவூட்டல்களையும் அழிக்க தோல்வி"
  },
  "calendar": {
    "title": "காலண்டர்",
    "today": "இன்று",
    "tomorrow": "நாளை",
    "completed": "முடிந்தது",
    "noEvents": "எதுவும் திட்டமிடப்படவில்லை",
    "noEventsSubtitle": "நினைவூட்டல்கள் மற்றும் காலண்டர் நிகழ்வுகளை பார்க்க ஒரு தேதியை தேர்ந்தெடுக்கவும்.",
    "googleEvent": "Google காலண்டர்",
    "legendActive": "செயலில் உள்ளது",
    "legendRecurring": "மீண்டும் நிகழும்",
    "legendDone": "முடிந்தது",
    "legendGoogle": "Google",
    "previousMonth": "முந்தைய மாதம்",
    "nextMonth": "அடுத்த மாதம்",
    "previousYear": "முந்தைய ஆண்டு",
    "nextYear": "அடுத்த ஆண்டு",
    "goToToday": "இன்றைக்கு செல்லவும்",
    "all": "அனைத்து",
    "active": "செயலில் உள்ளது",
    "done": "முடிந்தது",
    "paused": "நிறுத்தப்பட்டது"
  },
  "settings": {
    "title": "அமைப்புகள்",
    "profile": "சுயவிவரம்",
    "name": "காட்சி பெயர்",
    "enterName": "உங்கள் பெயரை உள்ளிடவும்",
    "language": "மொழி",
    "uiLanguage": "ஆப் மொழி",
    "uiLanguageHelp": "இந்த சாதனத்தில் மட்டும் ஆப் UI, காலண்டர் லேபிள்கள் மற்றும் அமைப்பு திசையை மாற்றுகிறது.",
    "serverLanguage": "சாட் மொழி",
    "serverLanguageHelp": "உங்கள் கணக்குக்கான சர்வர் பதில்கள் மற்றும் நினைவூட்டல் செய்திகளுக்கு பயன்படுத்தப்படும் மொழியை மாற்றுகிறது.",
    "timezone": "நேர மண்டலம்",
    "currentTimezone": "தற்போதைய நேர மண்டலம்",
    "timezoneHelp": "அனைத்து நினைவூட்டல் நேரங்கள் இந்த நேர மண்டலத்தை பயன்படுத்தி காட்டப்படும்.",
    "timezonePlaceholder": "America/New_York",
    "timezoneSave": "நேர மண்டலத்தை சேமி",
    "timezoneSaved": "நேர மண்டலம் புதுப்பிக்கப்பட்டது",
    "detect": "கண்டறி",
    "detectFailed": "நேர மண்டலம் கண்டறிய முடியவில்லை",
    "autoDetect": "GPS மூலம் தானாக கண்டறி",
    "notifications": "அறிவிப்புகள்",
    "notificationsHelp": "பின்வரும் நினைவூட்டல்கள் ஒரு நினைவூட்டல் வழங்கப்பட்ட பிறகு மீண்டும் எச்சரிக்கைகளை கட்டுப்படுத்தும். சாதன மட்ட அறிவிப்பு அனுமதிகள் உங்கள் தொலைபேசி அமைப்புகளில் நிர்வகிக்கப்படுகின்றன.",
    "pushEnabled": "புஷ் அறிவிப்புகள்",
    "autoDoneOnFire": "ஏற்றப்பட்டவுடன் தானாக முடி",
    "autoDoneOnFireDesc": "இயக்கமில்லாத போது, நினைவூட்டல்கள் நீங்கள் முடித்ததாக குறிக்கும் வரை செயலில் இருக்கும்.",
    "googleCalendar": "Google காலண்டர்",
    "google": "Google காலண்டர்",
    "googleConnected": "இணைக்கப்பட்டது",
    "googleDisconnected": "இணைக்கப்படவில்லை",
    "googleConnectedHelp": "புதிய நினைவூட்டல்கள் உங்கள் காலண்டருடன் தானாக இணைக்கப்படும்.",
    "googleDisconnectedHelp": "நினைவூட்டல்கள் மற்றும் நிகழ்வுகளை ஒத்திசைக்க Google காலண்டரை இணைக்கவும்.",
    "googleConnectFailed": "Google காலண்டர் இணைக்க தோல்வி",
    "connected": "இணைக்கப்பட்டது",
    "disconnected": "இணைக்கப்படவில்லை",
    "connect": "இணைக்கவும்",
    "disconnect": "தனித்து விடு",
    "autoSync": "புதிய நினைவூட்டல்களை தானாக ஒத்திசை",
    "autosync": "புதிய நினைவூட்டல்களை தானாக ஒத்திசை",
    "subscription": "சந்தா",
    "trialUsed": "சோதனை: {{used}}/{{total}} பயன்படுத்தப்பட்டது",
    "trialStatus": "சோதனை கிடைக்கும்",
    "activeStatus": "செயலில் உள்ள சந்தா",
    "expiredStatus": "சந்தா காலாவதி",
    "unsubscribedStatus": "சந்தா இல்லை",
    "about": "பற்றி",
    "version": "பதிப்பு",
    "logout": "வெளியேறு",
    "logoutTitle": "வெளியேறு",
    "logoutConfirm": "நீங்கள் வெளியேற விரும்புகிறீர்களா?",
    "noName": "பெயர் அமைக்கப்படவில்லை",
    "serverConnection": "சர்வர் இணைப்பு",
    "serverUrl": "சர்வர் URL",
    "serverEdit": "திருத்து",
    "saveReconnect": "சேமித்து மீண்டும் இணை",
    "resetDefault": "இயல்புநிலை மீட்டமை",
    "invalidServerUrlTitle": "தவறான சர்வர் URL",
    "invalidServerUrlMessage": "சரியான http அல்லது https சர்வர் URL ஐ உள்ளிடவும், உதாரணமாக https://example.com",
    "uiLanguageChangeFailed": "ஆப் மொழி மாற்றம் தோல்வி. மீண்டும் முயற்சி செய்க.",
    "serverLanguageChangeFailed": "சாட் மொழி மாற்றம் தோல்வி. மீண்டும் முயற்சி செய்க.",
    "timezoneChangeFailed": "நேர மண்டலம் மாற்றம் தோல்வி. மீண்டும் முயற்சி செய்க.",
    "autoSyncChangeFailed": "தானாக ஒத்திசை புதுப்பிப்பு தோல்வி. மீண்டும் முயற்சி செய்க.",
    "nameChangeFailed": "காட்சி பெயர் புதுப்பிப்பு தோல்வி. மீண்டும் முயற்சி செய்க.",
    "trialDays": "Free trial: {{daysLeft}} day(s) left",
    "trialEnds": "Trial ends {{date}}"
  },
  "reminder": {
    "body": "நினைவூட்டல் விவரங்கள்",
    "editTime": "நேரம் திருத்து",
    "rename": "மறுபெயர்",
    "snooze": "தாமதம் செய்",
    "snooze15": "15 நிமிடங்கள் தாமதம் செய்",
    "pause": "நிறுத்து",
    "pauseReminder": "நினைவூட்டலை நிறுத்து",
    "resume": "மீண்டும் தொடங்கு",
    "resumeReminder": "நினைவூட்டலை மீண்டும் தொடங்கு",
    "skip": "அடுத்ததை தவிர்க்கவும்",
    "skipOccurrence": "இந்த நிகழ்வை தவிர்க்கவும்",
    "syncGoogle": "Googleக்கு ஒத்திசை",
    "delete": "அழி",
    "deleteTitle": "நினைவூட்டலை அழி",
    "deleteConfirm": "இந்த நினைவூட்டல் நிரந்தரமாக அழிக்கப்படும்.",
    "deleteRecurringTitle": "மீண்டும் நிகழும் நினைவூட்டலை அழி",
    "deleteRecurringMessage": "இந்த நிகழ்வை தவிர்க்க விரும்புகிறீர்களா அல்லது முழு தொடர் அழிக்க விரும்புகிறீர்களா?",
    "deleteThisOccurrence": "இந்த நிகழ்வை தவிர்க்கவும்",
    "deleteEntireSeries": "முழு தொடர் அழி",
    "done": "முடிந்தது",
    "markDone": "முடிந்ததாக குறி",
    "undo": "மீட்டமை",
    "undoPrompt": "மீண்டும் செயலில் வேண்டும்? இப்போது மீட்டமைக்கவும்.",
    "recurring": "மீண்டும் நிகழும்",
    "nextRun": "அடுத்த இயக்கம்",
    "oneTime": "ஒருமுறை",
    "pending": "காத்திருக்கிறது",
    "sent": "அனுப்பப்பட்டது",
    "paused": "நிறுத்தப்பட்டது",
    "active": "செயலில் உள்ளது",
    "snoozed": "தாமதம் செய்யப்பட்டது",
    "localTime": "உங்கள் உள்ளூர் நேரத்தில் காட்டப்படுகிறது",
    "recurrence": "மீண்டும் நிகழும்",
    "created": "உருவாக்கப்பட்டது",
    "tags": "டேக்கள்",
    "fireCount": "முறைமைகள்",
    "actions": "செயல்கள்",
    "none": "இல்லை",
    "snoozeFailed": "நினைவூட்டலை தாமதம் செய்ய தோல்வி",
    "pauseFailed": "நினைவூட்டலை நிறுத்த தோல்வி",
    "resumeFailed": "நினைவூட்டலை மீண்டும் தொடங்க தோல்வி",
    "skipFailed": "நினைவூட்டலை தவிர்க்க தோல்வி",
    "doneFailed": "நினைவூட்டலை முடிந்ததாக குறிக்க தோல்வி",
    "undoFailed": "நினைவூட்டல் நிலையை மீட்டமைக்க தோல்வி",
    "deleteFailed": "நினைவூட்டலை அழிக்க தோல்வி",
    "rescheduleTitle": "மீண்டும் திட்டமிடலா?",
    "rescheduleMsg": "இந்த நினைவூட்டல் காலாவதியானது. அதை மீண்டும் திட்டமிட விரும்புகிறீர்களா?",
    "reschedule15": "15 நிமிடங்களில்",
    "reschedule60": "1 மணி நேரத்தில்",
    "keepOverdue": "அப்படியே வைக்கவும்"
  },
  "onboarding": {
    "slide1Title": "FishMemoryக்கு வரவேற்கிறோம்",
    "slide1Sub": "உங்கள் தனிப்பட்ட நினைவூட்டல் உதவியாளர் — WhatsApp மூலம் இயக்கப்படுகிறது மற்றும் உங்கள் கைக்காக உருவாக்கப்பட்டது.",
    "slide2Title": "சாதாரணமாக சாட் செய்யவும்",
    "slide2Sub": "நினைவூட்டல்களை உங்கள் எண்ணம் போல தட்டச்சு செய்க: \"நாளை 3 மணி மாமாவை அழைக்க நினைவூட்டவும்\" — மற்றவை நாங்கள் கவனிப்போம்.",
    "slide3Title": "ஒருபோதும் தவற விடாதீர்கள்",
    "slide3Sub": "சரியான நேர அறிவிப்புகளை பெறுங்கள், டேக்களுடன் ஒழுங்குபடுத்துங்கள், மற்றும் முக்கியமான அனைத்தையும் கண்காணிக்கவும்.",
    "getStarted": "தொடங்கு",
    "next": "அடுத்து",
    "firstReminderTitle": "உங்கள் முதல் நினைவூட்டலை உருவாக்குங்கள்!",
    "firstReminderHint": "இப்படிச் சொல்ல முயற்சி செய்க:",
    "firstReminderExample": "நாளை காலை 9 மணிக்கு தண்ணீர் குடிக்க நினைவூட்டவும்",
    "gotIt": "புரிந்தது!",
    "notifRationaleTitle": "சரியான நேரத்தில் இருங்கள்",
    "notifRationaleBody": "FishMemory நேரத்தில் நினைவூட்ட அறிவிப்புகளை வழங்க வேண்டும். நீங்கள் உருவாக்கிய நினைவூட்டல்களுக்கு மட்டுமே அறிவிப்புகள் வரும்.",
    "notifRationaleAllow": "அறிவிப்புகளை இயக்கவும்",
    "notifRationaleLater": "பிறகு பார்க்கலாம்",
    "swipeHint": "வலமாக ஸ்வைப் செய்து விரைவு செயல்கள் →",
    "calendarDragHint": "வீசவும் விரிவாக்க ↕"
  }
}
